import { render, staticRenderFns } from "./pushSapLeave.vue?vue&type=template&id=387cf7a6&scoped=true&"
import script from "./pushSapLeave.vue?vue&type=script&lang=js&"
export * from "./pushSapLeave.vue?vue&type=script&lang=js&"
import style0 from "./pushSapLeave.vue?vue&type=style&index=0&id=387cf7a6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387cf7a6",
  null
  
)

export default component.exports